// דיווחי באגים של הסוכנים (10 §10): system.bug_report של בינה-1/בינה-2 → sys.bug_report. ישות פנימית למפתח —
// לא נחשפת בשום נתיב /api; נקראת דרך tools/bugs.ts.
import { z } from 'zod';
import { Id, Json, rowBase } from './common.ts';

export const BugSeverity = z.enum(['low', 'medium', 'high']);
export type BugSeverity = z.infer<typeof BugSeverity>;
export const BugStatus = z.enum(['open', 'triaged', 'fixed', 'wontfix']);
export type BugStatus = z.infer<typeof BugStatus>;
export const BugReporter = z.enum(['ai1', 'ai2']);
export type BugReporter = z.infer<typeof BugReporter>;

/** מה שהסוכן מדווח (קלט הכלי). */
export const BugReportInput = z.object({
  title: z.string().min(3).max(200),
  severity: BugSeverity,
  whatHappened: z.string().min(1).max(8000),
  expected: z.string().min(1).max(4000),
  steps: z.string().max(8000).optional(),
  tool: z.string().max(120).optional(),
  evidence: z.string().max(16000).optional(),
});
export type BugReportInput = z.infer<typeof BugReportInput>;

/** קריאת כלי אחת מהתור, כפי שנלכדה אוטומטית (sys.turn_event: tool_use/tool_result). */
export const BugToolCall = z.object({
  seq: z.number().int(),
  name: z.string(),
  summaryHe: z.string().nullable(),
  ok: z.boolean().nullable(),
  errorHe: z.string().nullable(),
  ts: z.string(),
});
export type BugToolCall = z.infer<typeof BugToolCall>;

/** sys.bug_report */
export const BugReport = z.object({
  ...rowBase,
  worldKey: z.string().nullable(),
  conversationId: Id.nullable(),
  turnId: Id.nullable(),
  level: z.union([z.literal(1), z.literal(2)]),
  reporter: BugReporter,
  reporterUserId: Id.nullable(),
  title: z.string(),
  severity: BugSeverity,
  body: Json,
  toolContext: Json,
  model: z.string().nullable(),
  promptVersion: z.string().nullable(),
  status: BugStatus,
  devNote: z.string().nullable(),
});
export type BugReport = z.infer<typeof BugReport>;
